/**
 * @file: UUID类
 * @author: xiaolong.huang@dmall.com
 */

class UUID {
    id: string = '';

    constructor() {
        this.id = this.createUUID() + new Date().getTime();
    }

    createUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }
}

export default UUID;
